import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { DollarSign } from 'lucide-react';

export default function HospitalFinancialStatus({ totalClaims, hospitalBalance, hospitalCurrency, formatCurrency }) {
  const rate = hospitalCurrency.rate_to_usd || 1;
  const depositLocal = hospitalBalance / rate;
  const owed = totalClaims > depositLocal;

  return (
    <Card className={`shadow-md ${totalClaims > hospitalBalance ? 'border-green-300' : 'border-red-300'}`}>
      <CardHeader className={`bg-gradient-to-r ${totalClaims > hospitalBalance ? 'from-green-50 to-green-100 border-green-200' : 'from-red-50 to-red-100 border-red-200'} border-b p-3 sm:p-4`}>
        <CardTitle className={`${totalClaims > hospitalBalance ? 'text-green-900' : 'text-red-900'} text-sm sm:text-base`}>
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-2">
              <DollarSign className="w-4 h-4 sm:w-5 sm:h-5" />
              <span className="hidden sm:inline">This Month's </span>Financial Status
            </span>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-3 sm:pt-6">
        <div className="grid grid-cols-3 gap-2 sm:gap-6">
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2">Claims</p>
            <p className="text-lg sm:text-2xl font-bold text-blue-600">{formatCurrency(totalClaims)}</p>
          </div>
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2">Deposit</p>
            <p className="text-lg sm:text-2xl font-bold text-purple-600">{formatCurrency(depositLocal)}</p>
            {hospitalCurrency.code !== 'USD' && (
              <p className="text-xs text-gray-500 mt-1 hidden sm:block">
                (≈ $ {hospitalBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD)
              </p>
            )}
          </div>
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2">Net</p>
            <p className={`text-xl sm:text-3xl font-bold ${owed ? 'text-green-600' : 'text-red-600'}`}>
              {owed ? '+' : ''}{formatCurrency(totalClaims - depositLocal)}
            </p>
            <p className="text-xs text-gray-500 mt-1 hidden sm:block">
              {owed ? 'Insurance owes hospital' : totalClaims < depositLocal ? 'Hospital owes insurance' : 'Balanced'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
